import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api_auth_routes } from "../../config/apiRoutes";
import { API } from "../../config/config";
import { AuthState } from "../../types/types";

const initialState: AuthState = {
  loading: false,
  error: null,
  token: null,
  user: {
    id: "",
    role: "",
    username: "",
  },
};

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (
    formData: { username: string; password: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.POST(api_auth_routes.login, formData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      localStorage.removeItem("token");
      window.location.reload();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        localStorage.setItem("token", action.payload.token);
        state.user = action.payload.data;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
